interface ProductVariantAttribute {
  isVariantable?: boolean;
  name?: unknown;
  value?: unknown;
}

/** Katalogda tek bir varyant ekseni varsa kartta gerçek etiketini gösterir. */
export function getProductVariantLabel(product: {
  attributes?: unknown;
}): string {
  if (!Array.isArray(product.attributes)) return "";

  const variantAttributes = product.attributes.filter(
    (attribute): attribute is ProductVariantAttribute =>
      typeof attribute === "object" &&
      attribute !== null &&
      (attribute as ProductVariantAttribute).isVariantable === true,
  );
  if (variantAttributes.length !== 1) return "";

  const { name, value } = variantAttributes[0];
  return typeof name === "string" &&
    name.trim() !== "" &&
    typeof value === "string" &&
    value.trim() !== ""
    ? `${name}: ${value}`
    : "";
}
